<div class="container">
    <div class="row">
        <div class="col">
            <!-- Header Section -->
            <div class="text-center my-5">
                <h1 class="display-4 fw-bold text-primary">Funktionen</h1>
                <div class="border-bottom border-primary mx-auto" style="width: 100px; margin-top: 15px;"></div>
            </div>

            <!-- Quick Navigation -->
            <div class="card border-0 shadow-sm mb-5">
                <div class="card-body">
                    <h5 class="card-title text-primary mb-3">Schnellnavigation</h5>
                    <div class="row">
                        <div class="col-md-3 mb-2">
                            <a [routerLink]="[]" [fragment]="'Vertrag'" class="btn btn-outline-primary w-100">
                                <i class="fas fa-file-contract mr-2"></i>Vertragsmanagement
                            </a>
                        </div>
                        <div class="col-md-3 mb-2">
                            <a [routerLink]="[]" [fragment]="'Bescheid'" class="btn btn-outline-primary w-100">
                                <i class="fas fa-clipboard-check mr-2"></i>Bescheidmanagement
                            </a>
                        </div>
                        <div class="col-md-3 mb-2">
                            <a [routerLink]="[]" [fragment]="'Share'" class="btn btn-outline-primary w-100">
                                <i class="fas fa-share-alt mr-2"></i>FileShare
                            </a>
                        </div>
                        <div class="col-md-3 mb-2">
                            <a [routerLink]="[]" [fragment]="'Tagging'" class="btn btn-outline-primary w-100">
                                <i class="fas fa-tags mr-2"></i>Tagging-System
                            </a>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4 mb-2">
                            <a [routerLink]="[]" [fragment]="'Rollen'" class="btn btn-outline-primary w-100">
                                <i class="fas fa-user-shield mr-2"></i>Berechtigungssystem
                            </a>
                        </div>
                        <div class="col-md-4 mb-2">
                            <a [routerLink]="[]" [fragment]="'Digitalisierung'" class="btn btn-outline-primary w-100">
                                <i class="fas fa-magnifying-glass mr-2"></i>OCR-Technologie
                            </a>
                        </div>
                        <div class="col-md-4 mb-2">
                            <a [routerLink]="[]" [fragment]="'Sichtbarkeitsgruppen'" class="btn btn-outline-primary w-100">
                                <i class="fas fa-eye mr-2"></i>Sichtbarkeitsgruppen
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Introduction Card -->
            <div class="card border-0 shadow-sm mb-5 bg-light">
                <div class="card-body p-4">
                    <div class="row align-items-center">
                        <div class="col-md-12">
                            <h2 class="card-title text-primary mb-3">
                                <i class="fas fa-star mr-2"></i>Verpflichtungsmanagement neu definiert
                            </h2>
                            <p class="lead">
                                NoteRadar vereint Leistungsstärke mit Benutzerfreundlichkeit! Unsere schlanke, intuitive WebApp wurde speziell entwickelt, um komplexe Dokumentenprozesse zu vereinfachen.
                            </p>
                            <div class="row mt-4">
                                <div class="col-md-6">
                                    <div class="d-flex mb-3">
                                        <div class="flex-shrink-0">
                                            <i class="fas fa-check-circle text-success fa-2x mr-3"></i>
                                        </div>
                                        <div>
                                            <h5>Sofort einsatzbereit</h5>
                                            <p>Ohne lange Einarbeitungszeit für alle Teammitglieder</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="d-flex mb-3">
                                        <div class="flex-shrink-0">
                                            <i class="fas fa-laptop-house text-success fa-2x mr-3"></i>
                                        </div>
                                        <div>
                                            <h5>Überall verfügbar</h5>
                                            <p>Im Büro, unterwegs oder im Homeoffice</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--<div class="col-md-4 text-center">
                            <img src="assets/img/features/intro.png" class="img-fluid rounded shadow" alt="NoteRadar Features" onerror="this.style.display='none'">
                        </div>-->
                    </div>
                </div>
            </div>

            <!-- Vertragsmanagement Section Header -->
            <div id="Vertrag" class="my-5 pt-3">
                <h2 class="display-5 fw-bold text-primary">
                    <i class="fas fa-file-contract mr-3"></i>Vertragsmanagement
                </h2>
                <div class="border-bottom border-primary" style="width: 100px; margin: 15px 0 30px 0;"></div>
            </div>

            <!-- Vertragsmanagement Content -->
            <div class="row my-5">
                <div class="col-md-5 text-center">
                    <img src="assets/img/features/1.png" class="img-fluid rounded shadow-lg mb-4" alt="Vertragsmanagement">
                    <div class="card border-0 shadow-sm bg-primary text-white p-3 mb-4">
                        <div class="card-body text-center">
                            <h4 class="card-title">
                                <i class="fas fa-lightbulb mr-2"></i>Wussten Sie schon?
                            </h4>
                            <p class="card-text">
                                Unternehmen, die digitales Vertragsmanagement nutzen, reduzieren ihre Verwaltungskosten um bis zu 40% und verkürzen Bearbeitungszeiten um mehr als 50%.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-body">
                            <h3 class="card-title text-primary">
                                <i class="fas fa-upload mr-2"></i>Verträge intelligent digitalisieren und erschließen
                            </h3>
                            <p class="card-text">
                                Verwandeln Sie Ihre Papierverträge in durchsuchbare digitale Assets! Mit einem einfachen Upload werden Ihre Verträge automatisch indiziert und sofort für Ihre gesamte Organisation nutzbar gemacht.
                            </p>
                            <p class="card-text">
                                Personalisieren Sie Ihre Vertragsverwaltung mit maßgeschneiderten Attributen, ergänzen Sie wichtige Zusatzdokumente und verknüpfen Sie direkt relevante Aufgaben – alles in einem zentralen System.
                            </p>
                        </div>
                    </div>

                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-body">
                            <h3 class="card-title text-primary">
                                <i class="fas fa-search mr-2"></i>Blitzschnelle Vertragssuche
                            </h3>
                            <p class="card-text">
                                <span class="badge bg-danger mr-2">Schluss mit dem Suchen in Aktenordnern!</span> Die leistungsstarke Suchfunktion durchforstet nicht nur Vertragstitel und Metadaten, sondern auch den vollständigen Vertragsinhalt.
                            </p>
                            <p class="card-text">
                                Finden Sie in Sekundenschnelle spezifische Klauseln, Konditionen oder andere Details – selbst in umfangreichen Vertragswerken. Die intuitive hierarchische Struktur führt Sie direkt zu den gesuchten Informationen.
                            </p>
                        </div>
                    </div>

                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-body">
                            <h3 class="card-title text-primary">
                                <i class="fas fa-table mr-2"></i>Kristallklare Übersicht zu jeder Zeit
                            </h3>
                            <p class="card-text">
                                Behalten Sie den Überblick über Hunderte von Verträgen! Die dynamischen Tabellenansichten mit leistungsstarken Filter- und Sortierfunktionen ermöglichen es Ihnen,
                                genau die Verträge zu identifizieren, die für Ihre aktuelle Aufgabe relevant sind.
                            </p>
                            <p class="card-text">
                                Passen Sie die Ansicht an Ihre Bedürfnisse an und exportieren Sie bei Bedarf die gefilterten Daten.
                            </p>
                        </div>
                    </div>

                    <div class="card border-0 shadow-sm mb-4 bg-light">
                        <div class="card-body">
                            <h3 class="card-title text-primary">
                                <i class="fas fa-bell mr-2"></i>Proaktives Vertragsmanagement durch automatische Erinnerungen
                            </h3>
                            <ul class="list-group list-group-flush mt-3">
                                <li class="list-group-item bg-light">
                                    <i class="fas fa-check-circle text-success mr-2"></i>Rechtzeitige Benachrichtigungen vor Vertragsablauf – nie wieder verpasste Kündigungsfristen
                                </li>
                                <li class="list-group-item bg-light">
                                    <i class="fas fa-check-circle text-success mr-2"></i>Automatische Erinnerungen für anstehende Nachverhandlungen – optimieren Sie Ihre Vertragskonditionen
                                </li>
                                <li class="list-group-item bg-light">
                                    <i class="fas fa-check-circle text-success mr-2"></i>Individuelle Warnhinweise für kritische Vertragsereignisse – behalten Sie die Kontrolle
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="card border-0 shadow-sm bg-success text-white">
                        <div class="card-body">
                            <h3 class="card-title">
                                <i class="fas fa-chart-line mr-2"></i>Ihr strategischer Mehrwert
                            </h3>
                            <p class="card-text">
                                NoteRadar transformiert Ihre Verträge von passiven Dokumenten zu aktiven Geschäftswerkzeugen. Durch die intelligente Verteilung von Verantwortlichkeiten innerhalb Ihrer Organisation
                                werden Verträge nicht mehr nur verwaltet, sondern aktiv gestaltet und optimiert.
                            </p>
                            <div class="alert alert-light mt-3">
                                <strong>Das Ergebnis:</strong> Bessere Vertragskonditionen, reduzierte Risiken und signifikante Kosteneinsparungen.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Erinnerungssystem Section -->
            <div class="row my-5 align-items-center">
                <div class="col-md-7">
                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-header bg-primary text-white">
                            <h3 class="card-title mb-0">
                                <i class="fas fa-clock mr-2"></i>Intelligentes Erinnerungssystem
                            </h3>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-warning">
                                <i class="fas fa-exclamation-triangle mr-2"></i><strong>Verpassen Sie nie wieder wichtige Fristen!</strong>
                            </div>
                            <p class="card-text mt-3">
                                Das proaktive Erinnerungssystem von NoteRadar überwacht automatisch alle Ihre Termine und sendet rechtzeitig personalisierte E-Mail-Benachrichtigungen.
                            </p>
                            <div class="row mt-4">
                                <div class="col-md-6">
                                    <div class="d-flex mb-3">
                                        <div class="flex-shrink-0">
                                            <div class="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                                                <i class="fas fa-tasks"></i>
                                            </div>
                                        </div>
                                        <div class="ml-3">
                                            <h5>Flexible Aufgabenplanung</h5>
                                            <p>Erstellen Sie einmalige oder wiederkehrende Aufgaben mit individuellen Fälligkeitsdaten</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="d-flex mb-3">
                                        <div class="flex-shrink-0">
                                            <div class="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                                                <i class="fas fa-sliders-h"></i>
                                            </div>
                                        </div>
                                        <div class="ml-3">
                                            <h5>Anpassbare Vorlaufzeiten</h5>
                                            <p>Erhalten Sie Erinnerungen eine Woche, drei Tage oder 24 Stunden vor Fälligkeit</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card bg-light border-0 mt-3">
                                <div class="card-body">
                                    <p class="card-text">
                                        <strong>Schluss mit verpassten Fristen!</strong> Anders als passive Excel-Tabellen oder verstaubte Aktenordner arbeitet NoteRadar aktiv für Sie –
                                        und verwandelt Ihr Dokumentenmanagement von einer reaktiven Verwaltungsaufgabe in ein proaktives Steuerungsinstrument.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card border-0 shadow-sm">
                        <div class="card-header bg-info text-white">
                            <h3 class="card-title mb-0">
                                <i class="fas fa-tags mr-2"></i>Flexibles Tagging-System
                            </h3>
                        </div>
                        <div class="card-body">
                            <p class="card-text lead">
                                Organisieren Sie Ihre Daten nach Ihren eigenen Regeln!
                            </p>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="card bg-light border-0 mb-3">
                                        <div class="card-body">
                                            <h5 class="card-title text-info">
                                                <i class="fas fa-sitemap mr-2"></i>Maßgeschneiderte Kategorien
                                            </h5>
                                            <p class="card-text">
                                                Mit dem leistungsstarken Tagging-System können Sie in allen Bereichen (Dokumente, Aufgaben, Termine, Erinnerungen)
                                                maßgeschneiderte Kategorien erstellen.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="card bg-light border-0 mb-3">
                                        <div class="card-body">
                                            <h5 class="card-title text-info">
                                                <i class="fas fa-filter mr-2"></i>Präzise Filterung
                                            </h5>
                                            <p class="card-text">
                                                Die zentrale Tag-Übersicht bietet einen schnellen Zugriff auf alle verknüpften Elemente – mit einem Klick filtern Sie Ihre gesamte Datenbasis.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p class="card-text mt-3">
                                Markieren Sie Elemente für spezielle Projekte, Prioritätsstufen, Verantwortungsbereiche oder beliebige andere Kriterien –
                                und schaffen Sie so eine zusätzliche Organisationsebene, die perfekt zu Ihren Arbeitsabläufen passt.
                            </p>
                            <div class="d-flex mt-3">
                                <span class="badge bg-primary mr-2 p-2">Projekt Alpha</span>
                                <span class="badge bg-success mr-2 p-2">Hohe Priorität</span>
                                <span class="badge bg-warning text-dark mr-2 p-2">Vertrieb</span>
                                <span class="badge bg-info mr-2 p-2">Q4/2023</span>
                                <span class="badge bg-secondary mr-2 p-2">+</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 text-center">
                    <img src="assets/img/features/2.png" class="img-fluid rounded shadow-lg mb-4" alt="Erinnerungssystem">
                    <div class="card border-0 shadow-sm bg-light p-3">
                        <div class="card-body">
                            <h4 class="card-title text-primary">
                                <i class="fas fa-quote-left mr-2"></i>Kundenstimme
                            </h4>
                            <p class="card-text fst-italic">
                                "Seit wir NoteRadar einsetzen, haben wir keine einzige Frist mehr verpasst. Das System erinnert uns zuverlässig an alle wichtigen Termine und hat unsere Prozesssicherheit enorm verbessert."
                            </p>
                            <p class="text-end mb-0">
                                <small>- Maria S., Abteilungsleiterin</small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Multi-Location-Management Section -->
            <div class="row my-5 align-items-center">
                <div class="col-md-5 text-center">
                    <img src="assets/img/features/3.png" class="img-fluid rounded shadow-lg mb-4" alt="Multi-Location-Management">

                    <div class="card border-0 shadow-sm bg-primary text-white mb-4">
                        <div class="card-body">
                            <h4 class="card-title">
                                <i class="fas fa-building mr-2"></i>Ideal für:
                            </h4>
                            <div class="row text-center mt-3">
                                <div class="col-4">
                                    <div class="rounded-circle bg-white text-primary d-inline-flex justify-content-center align-items-center mb-2" style="width: 50px; height: 50px;">
                                        <i class="fas fa-store fa-lg"></i>
                                    </div>
                                    <p>Filialunternehmen</p>
                                </div>
                                <div class="col-4">
                                    <div class="rounded-circle bg-white text-primary d-inline-flex justify-content-center align-items-center mb-2" style="width: 50px; height: 50px;">
                                        <i class="fas fa-handshake fa-lg"></i>
                                    </div>
                                    <p>Franchise-Systeme</p>
                                </div>
                                <div class="col-4">
                                    <div class="rounded-circle bg-white text-primary d-inline-flex justify-content-center align-items-center mb-2" style="width: 50px; height: 50px;">
                                        <i class="fas fa-sitemap fa-lg"></i>
                                    </div>
                                    <p>Konzerne</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-header bg-primary text-white">
                            <h3 class="card-title mb-0">
                                <i class="fas fa-globe mr-2"></i>Multi-Location-Management für komplexe Unternehmensstrukturen
                            </h3>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-info">
                                <i class="fas fa-info-circle mr-2"></i>Verwalten Sie mühelos mehrere Unternehmen und zahlreiche Standorte in einem einzigen System!
                            </div>
                            <p class="card-text mt-3">
                                Die leistungsstarke hierarchische Struktur von NoteRadar bildet selbst komplexe Filialorganisationen präzise ab –
                                von der Konzernzentrale bis zur kleinsten Niederlassung. Jedes Dokument, jede Aufgabe und jeder Termin wird automatisch mit der richtigen Organisationseinheit verknüpft.
                            </p>

                            <div class="card bg-light border-0 mt-3 mb-3">
                                <div class="card-body">
                                    <h5 class="card-title text-primary">
                                        <i class="fas fa-binoculars mr-2"></i>Volle Transparenz
                                    </h5>
                                    <p class="card-text">
                                        Behalten Sie den Überblick über Ihre gesamte Organisation: Die klare Zuordnung von Verantwortlichkeiten zu Abteilungen und Mitarbeitern sorgt für Transparenz und verhindert, dass wichtige Aufgaben übersehen werden.
                                    </p>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-md-6">
                                    <div class="card border-0 shadow-sm h-100">
                                        <div class="card-body">
                                            <h5 class="card-title text-primary">
                                                <i class="fas fa-cogs mr-2"></i>Maßgeschneiderte Attribute
                                            </h5>
                                            <p class="card-text">
                                                Definieren Sie zentral beliebige Attribute für Ihre Betriebsstätten – von Größenkategorien über Umsatzklassen bis hin zu spezifischen Compliance-Anforderungen.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="card border-0 shadow-sm h-100">
                                        <div class="card-body">
                                            <h5 class="card-title text-primary">
                                                <i class="fas fa-chart-bar mr-2"></i>Standortübergreifende Analysen
                                            </h5>
                                            <p class="card-text">
                                                Filtern Sie nach bestimmten Kriterien, vergleichen Sie Standorte und exportieren Sie die Ergebnisse für weiterführende Auswertungen.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--<div class="text-center mt-4">
                                <button class="btn btn-outline-primary">
                                    <i class="fas fa-info-circle mr-2"></i>Mehr über Multi-Location-Management erfahren
                                </button>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>

            <!-- Bescheidmanagement Section Header -->
            <div id="Bescheid" class="my-5 pt-3">
                <h2 class="display-5 fw-bold text-primary">
                    <i class="fas fa-clipboard-check mr-3"></i>Professionelles Bescheidmanagement
                </h2>
                <div class="border-bottom border-primary" style="width: 100px; margin: 15px 0 30px 0;"></div>
            </div>

            <!-- Bescheidmanagement Content -->
            <div class="row my-5 align-items-center">
                <div class="col-md-7">
                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-header bg-success text-white">
                            <h3 class="card-title mb-0">
                                <i class="fas fa-file-alt mr-2"></i>Behördliche Bescheide effizient digitalisieren
                            </h3>
                        </div>
                        <div class="card-body">
                            <p class="card-text lead">
                                Verwandeln Sie Ihre behördlichen Bescheide in durchsuchbare digitale Ressourcen!
                            </p>
                            <div class="row mt-4">
                                <div class="col-md-6">
                                    <div class="d-flex mb-3">
                                        <div class="flex-shrink-0">
                                            <div class="rounded-circle bg-success text-white d-inline-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                                                <i class="fas fa-cloud-upload-alt"></i>
                                            </div>
                                        </div>
                                        <div class="ml-3">
                                            <h5>Automatische Indizierung</h5>
                                            <p>Nach dem Upload sofort für alle berechtigten Mitarbeiter zugänglich</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="d-flex mb-3">
                                        <div class="flex-shrink-0">
                                            <div class="rounded-circle bg-success text-white d-inline-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                                                <i class="fas fa-link"></i>
                                            </div>
                                        </div>
                                        <div class="ml-3">
                                            <h5>Direkte Verknüpfung</h5>
                                            <p>Verbinden Sie Bescheide mit den notwendigen Aufgaben zur Erfüllung</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-4">
                        <div class="col-md-6">
                            <div class="card border-0 shadow-sm h-100">
                                <div class="card-body">
                                    <h3 class="card-title text-success h5">
                                        <i class="fas fa-search mr-2"></i>Blitzschneller Zugriff
                                    </h3>
                                    <p class="card-text">
                                        Finden Sie in Sekundenschnelle genau den Bescheid, den Sie benötigen! Die leistungsstarke Suchfunktion durchsucht nicht nur Titel und Metadaten,
                                        sondern auch den vollständigen Inhalt Ihrer Bescheide.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card border-0 shadow-sm h-100">
                                <div class="card-body">
                                    <h3 class="card-title text-success h5">
                                        <i class="fas fa-table mr-2"></i>Vollständige Transparenz
                                    </h3>
                                    <p class="card-text">
                                        Behalten Sie den Überblick über sämtliche behördlichen Anforderungen mit dynamischen Tabellenansichten und umfangreichen Filter- und Sortierfunktionen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card border-0 shadow-sm mb-4 bg-light">
                        <div class="card-body">
                            <h3 class="card-title text-success">
                                <i class="fas fa-bell mr-2"></i>Proaktives Auflagenmanagement durch intelligente Erinnerungen
                            </h3>
                            <div class="row mt-3">
                                <div class="col-md-4">
                                    <div class="card bg-white border-0 shadow-sm mb-3 text-center h-100">
                                        <div class="card-body">
                                            <i class="fas fa-calendar-check text-success fa-2x mb-3"></i>
                                            <h5>Automatische Benachrichtigungen</h5>
                                            <p class="small">Keine Compliance-Verstöße mehr durch verpasste Fristen</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card bg-white border-0 shadow-sm mb-3 text-center h-100">
                                        <div class="card-body">
                                            <i class="fas fa-tools text-success fa-2x mb-3"></i>
                                            <h5>Wartungserinnerungen</h5>
                                            <p class="small">Perfekte Planung für vorgeschriebene Prüfungen</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card bg-white border-0 shadow-sm mb-3 text-center h-100">
                                        <div class="card-body">
                                            <i class="fas fa-exclamation-triangle text-success fa-2x mb-3"></i>
                                            <h5>Warnhinweise</h5>
                                            <p class="small">Behalten Sie stets die Kontrolle über kritische Anforderungen</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <img src="assets/img/features/1.png" class="img-fluid rounded shadow-lg mb-4" alt="Bescheidmanagement">

                    <div class="card border-0 shadow-sm bg-success text-white">
                        <div class="card-body">
                            <h4 class="card-title">
                                <i class="fas fa-balance-scale mr-2"></i>Ihr strategischer Compliance-Vorteil
                            </h4>
                            <p class="card-text">
                                NoteRadar transformiert Ihre behördlichen Bescheide von passiven Dokumenten zu aktiven Compliance-Werkzeugen. Durch die intelligente Verteilung von Verantwortlichkeiten
                                innerhalb Ihrer Organisation werden Bescheidauflagen nicht mehr nur erfüllt, sondern aktiv in Ihre Betriebsprozesse integriert.
                            </p>
                            <div class="alert alert-light text-success mt-3">
                                <strong>Das Ergebnis:</strong> Höhere Rechtssicherheit, reduzierte Compliance-Risiken und ein reibungsloser Betriebsablauf.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Mehrjährige Auflagenplanung Section -->
            <div class="row my-5 align-items-center">
                <div class="col-md-5 text-center">
                    <img src="assets/img/features/5.png" class="img-fluid rounded shadow-lg mb-4" alt="Mehrjährige Auflagenplanung">

                    <div class="card border-0 shadow-sm bg-light p-4">
                        <div class="card-body">
                            <div class="d-flex align-items-center mb-3">
                                <div class="flex-shrink-0">
                                    <i class="fas fa-calendar-alt text-success fa-3x mr-3"></i>
                                </div>
                                <div>
                                    <h4 class="card-title text-success mb-0">Langfristige Planung</h4>
                                    <p class="text-muted mb-0">Für maximale Planungssicherheit</p>
                                </div>
                            </div>
                            <div class="progress mt-3 mb-2">
                                <div class="progress-bar bg-success" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <div class="d-flex justify-content-between small text-muted">
                                <span>2023</span>
                                <span>2024</span>
                                <span>2025</span>
                                <span>2026</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="card border-0 shadow-sm">
                        <div class="card-header bg-success text-white">
                            <h3 class="card-title mb-0">
                                <i class="fas fa-calendar-alt mr-2"></i>Mehrjährige Auflagenplanung mit Jahresübersicht
                            </h3>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-success">
                                <i class="fas fa-check-circle mr-2"></i><strong>Behalten Sie den Überblick über alle wiederkehrenden Bescheidauflagen – auch über mehrere Jahre hinweg!</strong>
                            </div>

                            <p class="card-text mt-3">
                                Besonders für Filialorganisationen bietet die mehrjährige Übersicht eine unverzichtbare Planungshilfe für jeden Standort.
                                Sehen Sie auf einen Blick, welche Prüfungen, Wartungen und Maßnahmen in den kommenden Jahren anstehen.
                            </p>

                            <div class="card bg-light border-0 mt-4 mb-4">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h5 class="card-title text-success">
                                                <i class="fas fa-chess mr-2"></i>Strategische Ressourcenplanung
                                            </h5>
                                            <p class="card-text">
                                                Die übersichtliche Darstellung unterstützt Sie bei der strategischen Ressourcenplanung und stellt sicher, dass alle behördlichen Anforderungen termingerecht erfüllt werden.
                                            </p>
                                        </div>
                                        <div class="col-md-6">
                                            <h5 class="card-title text-success">
                                                <i class="fas fa-building mr-2"></i>Ideal für komplexe Organisationen
                                            </h5>
                                            <p class="card-text">
                                                Perfekt für Unternehmen mit zahlreichen Standorten und vielfältigen Compliance-Anforderungen!
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row text-center">
                                <div class="col-md-4">
                                    <div class="rounded-circle bg-success text-white d-inline-flex justify-content-center align-items-center mb-3" style="width: 60px; height: 60px;">
                                        <i class="fas fa-tasks fa-lg"></i>
                                    </div>
                                    <h5>Aufgabenplanung</h5>
                                    <p class="small">Planen Sie Ressourcen für wiederkehrende Aufgaben</p>
                                </div>
                                <div class="col-md-4">
                                    <div class="rounded-circle bg-success text-white d-inline-flex justify-content-center align-items-center mb-3" style="width: 60px; height: 60px;">
                                        <i class="fas fa-chart-line fa-lg"></i>
                                    </div>
                                    <h5>Trendanalyse</h5>
                                    <p class="small">Erkennen Sie Muster und optimieren Sie Prozesse</p>
                                </div>
                                <div class="col-md-4">
                                    <div class="rounded-circle bg-success text-white d-inline-flex justify-content-center align-items-center mb-3" style="width: 60px; height: 60px;">
                                        <i class="fas fa-file-invoice-dollar fa-lg"></i>
                                    </div>
                                    <h5>Budgetplanung</h5>
                                    <p class="small">Kalkulieren Sie Kosten für zukünftige Perioden</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- FileShare Section Header -->
            <div id="Share" class="my-5 pt-3">
                <h2 class="display-5 fw-bold text-primary">
                    <i class="fas fa-share-alt mr-3"></i>Sicherer FileShare für optimale Zusammenarbeit
                </h2>
                <div class="border-bottom border-primary" style="width: 100px; margin: 15px 0 30px 0;"></div>
            </div>

            <!-- FileShare Introduction -->
            <div class="card border-0 shadow-sm mb-5 bg-light">
                <div class="card-body p-4">
                    <div class="row align-items-center">
                        <div class="col-md-8">
                            <h3 class="card-title text-primary mb-3">
                                <i class="fas fa-lock mr-2"></i>Sicher, einfach und DSGVO-konform
                            </h3>
                            <p class="lead">
                                Teilen Sie wichtige Dokumente sicher und unkompliziert! Mit dem integrierten FileShare-Modul können Sie beliebige Dokumente zentral verwalten und bei Bedarf gezielt mit externen Partnern teilen.
                            </p>
                            <div class="alert alert-info mt-3">
                                <i class="fas fa-info-circle mr-2"></i>Externe Partner benötigen keinen eigenen NoteRadar-Zugang.
                            </div>
                            <div class="d-flex align-items-center mt-4">
                                <div class="mr-4 text-center">
                                    <div class="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center mb-2" style="width: 50px; height: 50px;">
                                        <i class="fas fa-shield-alt fa-lg"></i>
                                    </div>
                                    <p class="small mb-0">Verschlüsselte<br>Speicherung</p>
                                </div>
                                <div class="mr-4 text-center">
                                    <div class="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center mb-2" style="width: 50px; height: 50px;">
                                        <i class="fas fa-server fa-lg"></i>
                                    </div>
                                    <p class="small mb-0">Server in<br>Österreich</p>
                                </div>
                                <div class="text-center">
                                    <div class="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center mb-2" style="width: 50px; height: 50px;">
                                        <i class="fas fa-user-shield fa-lg"></i>
                                    </div>
                                    <p class="small mb-0">Europäische<br>Datenschutzstandards</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 text-center">
                            <div class="mt-3">
                                <span class="badge bg-success p-2 mr-2">DSGVO-konform</span>
                                <span class="badge bg-primary p-2">Verschlüsselt</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- FileShare Content -->
            <div class="row my-5 align-items-center">
                <div class="col-md-7">
                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-header bg-primary text-white">
                            <h3 class="card-title mb-0">
                                <i class="fas fa-file-alt mr-2"></i>Universelle Dokumentenverwaltung
                            </h3>
                        </div>
                        <div class="card-body">
                            <p class="card-text">
                                Speichern Sie nahezu alle gängigen Dateiformate in Ihrem sicheren FileShare-Bereich – von Geschäftsdokumenten (Word, Excel, PDF) über Präsentationen
                                bis hin zu Bildern und technischen Unterlagen.
                            </p>

                            <div class="row mt-4 text-center">
                                <div class="col-md-3 col-6 mb-3">
                                    <div class="p-2 bg-light rounded mb-2">
                                        <i class="fas fa-file-word text-primary fa-2x"></i>
                                    </div>
                                    <p class="small">Word</p>
                                </div>
                                <div class="col-md-3 col-6 mb-3">
                                    <div class="p-2 bg-light rounded mb-2">
                                        <i class="fas fa-file-excel text-success fa-2x"></i>
                                    </div>
                                    <p class="small">Excel</p>
                                </div>
                                <div class="col-md-3 col-6 mb-3">
                                    <div class="p-2 bg-light rounded mb-2">
                                        <i class="fas fa-file-pdf text-danger fa-2x"></i>
                                    </div>
                                    <p class="small">PDF</p>
                                </div>
                                <div class="col-md-3 col-6 mb-3">
                                    <div class="p-2 bg-light rounded mb-2">
                                        <i class="fas fa-file-image text-info fa-2x"></i>
                                    </div>
                                    <p class="small">Bilder</p>
                                </div>
                            </div>

                            <div class="alert alert-light mt-3">
                                <i class="fas fa-th mr-2"></i>Die flexible Ansicht lässt sich nach Ihren Vorlieben zwischen übersichtlicher Tabellenform und visueller Kacheldarstellung umschalten.
                            </div>
                        </div>
                    </div>

                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-header bg-primary text-white">
                            <h3 class="card-title mb-0">
                                <i class="fas fa-handshake mr-2"></i>Nahtlose externe Zusammenarbeit
                            </h3>
                        </div>
                        <div class="card-body">
                            <div class="d-flex align-items-center mb-4">
                                <div class="flex-shrink-0">
                                    <div class="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center" style="width: 60px; height: 60px;">
                                        <i class="fas fa-link fa-lg"></i>
                                    </div>
                                </div>
                                <div class="ml-3">
                                    <h5>Sichere Download-Links mit wenigen Klicks</h5>
                                    <p>Arbeiten Sie effizient mit externen Partnern zusammen, ohne zusätzliche Benutzerkonten verwalten zu müssen!</p>
                                </div>
                            </div>

                            <p class="card-text">
                                Mit wenigen Klicks generieren Sie sichere Download-Links, die Sie per E-Mail an Ihre Geschäftspartner, Kunden oder Lieferanten senden können.
                                Die Empfänger erhalten sofortigen Zugriff auf genau die Dokumente, die Sie freigeben möchten – nicht mehr und nicht weniger.
                            </p>
                        </div>
                    </div>

                    <div class="card border-0 shadow-sm">
                        <div class="card-header bg-primary text-white">
                            <h3 class="card-title mb-0">
                                <i class="fas fa-shield-alt mr-2"></i>Maximale Sicherheit durch umfassende Konfigurationsoptionen
                            </h3>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item d-flex">
                                            <i class="fas fa-clock text-primary mr-3 mt-1"></i>
                                            <div>
                                                <strong>Zeitliche Begrenzung</strong>
                                                <p class="small mb-0">Legen Sie präzise fest, wie lange ein Link gültig sein soll – von wenigen Stunden bis zu mehreren Wochen</p>
                                            </div>
                                        </li>
                                        <li class="list-group-item d-flex">
                                            <i class="fas fa-user-lock text-primary mr-3 mt-1"></i>
                                            <div>
                                                <strong>Zugriffssteuerung</strong>
                                                <p class="small mb-0">Beschränken Sie den Zugriff auf einmaligen Abruf oder erlauben Sie mehrfache Downloads</p>
                                            </div>
                                        </li>
                                        <li class="list-group-item d-flex">
                                            <i class="fas fa-key text-primary mr-3 mt-1"></i>
                                            <div>
                                                <strong>Zusätzlicher Passwortschutz</strong>
                                                <p class="small mb-0">Erhöhen Sie die Sicherheit durch ein separates Passwort, das Sie über einen anderen Kommunikationskanal übermitteln</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item d-flex">
                                            <i class="fas fa-users text-primary mr-3 mt-1"></i>
                                            <div>
                                                <strong>Gezielte Empfängerauswahl</strong>
                                                <p class="small mb-0">Definieren Sie exakt, welche Personen oder Organisationen Zugriff erhalten sollen</p>
                                            </div>
                                        </li>
                                        <li class="list-group-item d-flex">
                                            <i class="fas fa-clipboard-list text-primary mr-3 mt-1"></i>
                                            <div>
                                                <strong>Zugriffsprotokolle</strong>
                                                <p class="small mb-0">Behalten Sie den Überblick, wer wann auf Ihre geteilten Dokumente zugegriffen hat</p>
                                            </div>
                                        </li>
                                        <li class="list-group-item d-flex">
                                            <i class="fas fa-file-contract text-primary mr-3 mt-1"></i>
                                            <div>
                                                <strong>Rechtssicherheit</strong>
                                                <p class="small mb-0">Dokumentieren Sie alle Zugriffe lückenlos für Compliance- und Audit-Zwecke</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 text-center">
                    <img src="assets/img/features/4.png" class="img-fluid rounded shadow-lg mb-4" alt="FileShare Features">

                    <div class="card border-0 shadow-sm bg-primary text-white">
                        <div class="card-body">
                            <h4 class="card-title">
                                <i class="fas fa-shield-alt mr-2"></i>Sicherheit hat Priorität
                            </h4>
                            <p class="card-text">
                                Alle Ihre Daten werden mit modernsten Verschlüsselungstechnologien geschützt. Die Übertragung erfolgt ausschließlich über sichere HTTPS-Verbindungen,
                                und die Speicherung auf unseren Servern in Österreich erfolgt ebenfalls verschlüsselt.
                            </p>
                            <div class="text-center mt-3">
                                <i class="fas fa-lock fa-3x"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tagging-System Section Header -->
            <div id="Tagging" class="my-5 pt-3">
                <h2 class="display-5 fw-bold text-primary">
                    <i class="fas fa-tags mr-3"></i>Intelligentes Tagging-System
                </h2>
                <div class="border-bottom border-primary" style="width: 100px; margin: 15px 0 30px 0;"></div>
            </div>

            <!-- Tagging-System Content -->
            <div class="card border-0 shadow-sm mb-5">
                <div class="card-body p-4">
                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <h3 class="card-title text-primary mb-4">
                                <i class="fas fa-sitemap mr-2"></i>Organisieren Sie Ihre Daten nach Ihren eigenen Regeln!
                            </h3>
                            <p class="lead">
                                Mit dem leistungsstarken Tagging-System können Sie alle Elemente in NoteRadar mit frei definierbaren Schlagworten versehen.
                            </p>
                            <div class="alert alert-info mt-3">
                                <i class="fas fa-info-circle mr-2"></i>Erstellen Sie maßgeschneiderte Kategorien für Projekte, Prioritäten, Abteilungen oder beliebige andere Kriterien.
                            </div>

                            <div class="mt-4">
                                <h5 class="text-primary"><i class="fas fa-filter mr-2"></i>Präzise Filterung</h5>
                                <p>
                                    Die zentrale Tag-Übersicht bietet einen schnellen Zugriff auf alle verknüpften Elemente – mit einem Klick filtern Sie Ihre gesamte Datenbasis nach genau den Kriterien,
                                    die für Ihre aktuelle Aufgabe relevant sind.
                                </p>
                                <p>
                                    Kombinieren Sie mehrere Tags für noch präzisere Ergebnisse und schaffen Sie so eine zusätzliche Organisationsebene, die perfekt zu Ihren Arbeitsabläufen passt!
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="card border-0 shadow-sm bg-light p-4">
                                <div class="card-body">
                                    <h4 class="card-title text-primary mb-4">
                                        <i class="fas fa-thumbtack mr-2"></i>Anwendungsbeispiele
                                    </h4>

                                    <div class="d-flex align-items-center mb-4">
                                        <div class="flex-shrink-0">
                                            <div class="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                                                <i class="fas fa-building"></i>
                                            </div>
                                        </div>
                                        <div class="ml-3">
                                            <h5>Unternehmen & Betriebsstätten</h5>
                                            <p class="mb-0">Kategorisieren Sie nach Größe, Region oder Geschäftsbereich</p>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center mb-4">
                                        <div class="flex-shrink-0">
                                            <div class="rounded-circle bg-success text-white d-inline-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                                                <i class="fas fa-file-alt"></i>
                                            </div>
                                        </div>
                                        <div class="ml-3">
                                            <h5>Dokumente</h5>
                                            <p class="mb-0">Ordnen Sie nach Dokumenttyp, Abteilung oder Wichtigkeit</p>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center">
                                        <div class="flex-shrink-0">
                                            <div class="rounded-circle bg-info text-white d-inline-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                                                <i class="fas fa-tasks"></i>
                                            </div>
                                        </div>
                                        <div class="ml-3">
                                            <h5>Aufgaben & Termine</h5>
                                            <p class="mb-0">Gruppieren Sie nach Projekt, Priorität oder Verantwortlichem</p>
                                        </div>
                                    </div>

                                    <div class="mt-4 p-3 bg-white rounded shadow-sm">
                                        <h5 class="text-center mb-3">Beispiel für Tag-Kombinationen</h5>
                                        <div class="d-flex flex-wrap justify-content-center">
                                            <span class="badge bg-primary m-1 p-2">Vertrag</span>
                                            <span class="badge bg-success m-1 p-2">Hochpriorität</span>
                                            <span class="badge bg-danger m-1 p-2">Fristgebunden</span>
                                            <span class="badge bg-warning text-dark m-1 p-2">Rechtsabteilung</span>
                                            <span class="badge bg-info m-1 p-2">Q2/2023</span>
                                            <span class="badge bg-secondary m-1 p-2">Lieferant A</span>
                                            <span class="badge bg-dark m-1 p-2">Standort München</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Berechtigungssystem Section Header -->
            <div id="Rollen" class="my-5 pt-3">
                <h2 class="display-5 fw-bold text-primary">
                    <i class="fas fa-user-shield mr-3"></i>Granulares Berechtigungssystem für maximale Sicherheit
                </h2>
                <div class="border-bottom border-primary" style="width: 100px; margin: 15px 0 30px 0;"></div>
            </div>

            <!-- Berechtigungssystem Content -->
            <div class="row my-5 align-items-center">
                <div class="col-md-7">
                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-header bg-dark text-white">
                            <h3 class="card-title mb-0">
                                <i class="fas fa-lock mr-2"></i>Volle Kontrolle über Ihre sensiblen Daten
                            </h3>
                        </div>
                        <div class="card-body">
                            <p class="card-text lead">
                                Das ausgefeilte rollenbasierte Berechtigungssystem von NoteRadar ermöglicht eine präzise Steuerung der Zugriffsrechte.
                            </p>

                            <div class="row mt-4">
                                <div class="col-md-6">
                                    <div class="card bg-light border-0 h-100">
                                        <div class="card-body">
                                            <h5 class="card-title text-dark">
                                                <i class="fas fa-shield-alt mr-2"></i>Vordefinierte Standardrollen
                                            </h5>
                                            <p class="card-text">
                                                Die fünf vordefinierten Standardrollen decken die gängigsten Anwendungsfälle ab und ermöglichen einen schnellen Start.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="card bg-light border-0 h-100">
                                        <div class="card-body">
                                            <h5 class="card-title text-dark">
                                                <i class="fas fa-cogs mr-2"></i>Maßgeschneiderte Rollen
                                            </h5>
                                            <p class="card-text">
                                                Erstellen Sie beliebig viele maßgeschneiderte Rollen mit individuellen Rechtekombinationen für Ihre spezifischen Anforderungen.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="alert alert-dark mt-4">
                                <i class="fas fa-info-circle mr-2"></i>Weisen Sie Berechtigungen gezielt nach Abteilungen, Funktionen oder Projekten zu und stellen Sie sicher, dass jeder Mitarbeiter genau die Zugriffsrechte erhält, die er für seine Aufgaben benötigt – nicht mehr und nicht weniger.
                            </div>

                            <div class="text-center mt-4">
                                <h5 class="text-dark mb-3">Das Ergebnis:</h5>
                                <div class="d-flex justify-content-center">
                                    <div class="mx-3 text-center">
                                        <div class="rounded-circle bg-dark text-white d-inline-flex justify-content-center align-items-center mb-2" style="width: 60px; height: 60px;">
                                            <i class="fas fa-shield-alt fa-lg"></i>
                                        </div>
                                        <p>Maximale<br>Datensicherheit</p>
                                    </div>
                                    <div class="mx-3 text-center">
                                        <div class="rounded-circle bg-dark text-white d-inline-flex justify-content-center align-items-center mb-2" style="width: 60px; height: 60px;">
                                            <i class="fas fa-tachometer-alt fa-lg"></i>
                                        </div>
                                        <p>Optimale<br>Arbeitseffizienz</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-header bg-dark text-white">
                            <h4 class="card-title mb-0">
                                <i class="fas fa-layer-group mr-2"></i>Zugriffsebenen
                            </h4>
                        </div>
                        <div class="card-body p-0">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item d-flex align-items-center">
                                    <div class="rounded-circle bg-danger text-white d-inline-flex justify-content-center align-items-center mr-3" style="width: 40px; height: 40px;">
                                        <i class="fas fa-eye-slash"></i>
                                    </div>
                                    <div>
                                        <h5 class="mb-1">Kein Zugriff</h5>
                                        <p class="mb-0 small">Elemente sind vollständig ausgeblendet</p>
                                    </div>
                                </li>
                                <li class="list-group-item d-flex align-items-center">
                                    <div class="rounded-circle bg-warning text-dark d-inline-flex justify-content-center align-items-center mr-3" style="width: 40px; height: 40px;">
                                        <i class="fas fa-eye"></i>
                                    </div>
                                    <div>
                                        <h5 class="mb-1">Ansicht</h5>
                                        <p class="mb-0 small">Nur Übersichten ohne Details sichtbar</p>
                                    </div>
                                </li>
                                <li class="list-group-item d-flex align-items-center">
                                    <div class="rounded-circle bg-info text-white d-inline-flex justify-content-center align-items-center mr-3" style="width: 40px; height: 40px;">
                                        <i class="fas fa-book-open"></i>
                                    </div>
                                    <div>
                                        <h5 class="mb-1">Leserechte</h5>
                                        <p class="mb-0 small">Vollständiger Lesezugriff auf alle Details</p>
                                    </div>
                                </li>
                                <li class="list-group-item d-flex align-items-center">
                                    <div class="rounded-circle bg-success text-white d-inline-flex justify-content-center align-items-center mr-3" style="width: 40px; height: 40px;">
                                        <i class="fas fa-edit"></i>
                                    </div>
                                    <div>
                                        <h5 class="mb-1">Bearbeitungsrechte</h5>
                                        <p class="mb-0 small">Ändern und Aktualisieren von Inhalten</p>
                                    </div>
                                </li>
                                <li class="list-group-item d-flex align-items-center">
                                    <div class="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center mr-3" style="width: 40px; height: 40px;">
                                        <i class="fas fa-user-cog"></i>
                                    </div>
                                    <div>
                                        <h5 class="mb-1">Administratorrechte</h5>
                                        <p class="mb-0 small">Vollständige Kontrolle inkl. Systemeinstellungen</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- OCR-Technologie Section Header -->
            <div id="Digitalisierung" class="my-5 pt-3">
                <h2 class="display-5 fw-bold text-primary">
                    <i class="fas fa-magnifying-glass mr-3"></i>Fortschrittliche OCR-Technologie für Ihre Digitalisierungsstrategie
                </h2>
                <div class="border-bottom border-primary" style="width: 100px; margin: 15px 0 30px 0;"></div>
            </div>

            <!-- OCR-Technologie Content -->
            <div class="row my-5 align-items-center">
                <div class="col-lg-6">
                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-header bg-info text-white">
                            <h3 class="card-title mb-0">
                                <i class="fas fa-file-alt mr-2"></i>Intelligente Dokumentendigitalisierung
                            </h3>
                        </div>
                        <div class="card-body">
                            <p class="card-text lead">
                                Transformieren Sie Ihre Papierdokumente in wertvolle digitale Assets!
                            </p>

                            <div class="alert alert-info mt-3">
                                <i class="fas fa-info-circle mr-2"></i>Jedes in NoteRadar hochgeladene Dokument wird automatisch mittels modernster <a href="https://de.wikipedia.org/wiki/Texterkennung" target="_blank" class="alert-link">OCR-Technologie</a> (Optical Character Recognition) analysiert und der erkannte Text wird indiziert.
                            </div>

                            <div class="mt-4">
                                <div class="d-flex align-items-center mb-3">
                                    <div class="flex-shrink-0">
                                        <div class="rounded-circle bg-info text-white d-inline-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                                            <i class="fas fa-search"></i>
                                        </div>
                                    </div>
                                    <div class="ml-3">
                                        <h5>Vollständig durchsuchbar</h5>
                                        <p class="mb-0">Selbst gescannte Dokumente werden durchsuchbar und erschließen Ihnen den gesamten Inhalt für die weitere Nutzung.</p>
                                    </div>
                                </div>

                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0">
                                        <div class="rounded-circle bg-info text-white d-inline-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                                            <i class="fas fa-copy"></i>
                                        </div>
                                    </div>
                                    <div class="ml-3">
                                        <h5>Einfache Textextraktion</h5>
                                        <p class="mb-0">Extrahieren Sie wichtige Textpassagen mit einem einfachen Kopieren und Einfügen – ideal für die Erstellung von Aufgabenbeschreibungen, Zusammenfassungen oder Berichten.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="card border-0 shadow-sm bg-light">
                        <div class="card-body p-4">
                            <h4 class="card-title text-info mb-4">
                                <i class="fas fa-cogs mr-2"></i>So funktioniert die OCR-Technologie
                            </h4>

                            <div class="row text-center">
                                <div class="col-md-3 col-6 mb-4">
                                    <div class="rounded-circle bg-white shadow-sm d-inline-flex justify-content-center align-items-center mb-3" style="width: 70px; height: 70px;">
                                        <i class="fas fa-upload text-info fa-2x"></i>
                                    </div>
                                    <h6>1. Upload</h6>
                                    <p class="small">Dokument hochladen</p>
                                </div>
                                <div class="col-md-3 col-6 mb-4">
                                    <div class="rounded-circle bg-white shadow-sm d-inline-flex justify-content-center align-items-center mb-3" style="width: 70px; height: 70px;">
                                        <i class="fas fa-magic text-info fa-2x"></i>
                                    </div>
                                    <h6>2. Analyse</h6>
                                    <p class="small">OCR-Erkennung</p>
                                </div>
                                <div class="col-md-3 col-6 mb-4">
                                    <div class="rounded-circle bg-white shadow-sm d-inline-flex justify-content-center align-items-center mb-3" style="width: 70px; height: 70px;">
                                        <i class="fas fa-database text-info fa-2x"></i>
                                    </div>
                                    <h6>3. Indizierung</h6>
                                    <p class="small">Textindexierung</p>
                                </div>
                                <div class="col-md-3 col-6 mb-4">
                                    <div class="rounded-circle bg-white shadow-sm d-inline-flex justify-content-center align-items-center mb-3" style="width: 70px; height: 70px;">
                                        <i class="fas fa-check-circle text-info fa-2x"></i>
                                    </div>
                                    <h6>4. Nutzung</h6>
                                    <p class="small">Sofort verfügbar</p>
                                </div>
                            </div>

                            <div class="card bg-white border-0 shadow-sm mt-3">
                                <div class="card-body">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-shrink-0">
                                            <i class="fas fa-users-cog text-info fa-3x mr-3"></i>
                                        </div>
                                        <div>
                                            <h5>Expertenunterstützung</h5>
                                            <p class="mb-0">Unser Expertenteam unterstützt Sie bei Bedarf mit maßgeschneiderten Digitalisierungslösungen, von der optimalen Dokumentenaufbereitung bis hin zur strategischen Implementierung in Ihre Geschäftsprozesse.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Sichtbarkeitsgruppen Section Header -->
            <div id="Sichtbarkeitsgruppen" class="my-5 pt-3">
                <h2 class="display-5 fw-bold text-primary">
                    <i class="fas fa-eye mr-3"></i>Maßgeschneiderte Vertraulichkeitsstufen mit Sichtbarkeitsgruppen
                </h2>
                <div class="border-bottom border-primary" style="width: 100px; margin: 15px 0 30px 0;"></div>
            </div>

            <!-- Sichtbarkeitsgruppen Content -->
            <div class="row my-5 align-items-center">
                <div class="col-md-7">
                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-header bg-secondary text-white">
                            <h3 class="card-title mb-0">
                                <i class="fas fa-user-secret mr-2"></i>Zuverlässiger Schutz sensibler Informationen
                            </h3>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-warning">
                                <i class="fas fa-exclamation-triangle mr-2"></i><strong>Schützen Sie sensible Informationen zuverlässig vor unbefugtem Zugriff!</strong>
                            </div>

                            <p class="card-text mt-3">
                                Mit dem innovativen Konzept der Sichtbarkeitsgruppen können Sie für vertrauliche Dokumente präzise festlegen,
                                welche Benutzer Zugriff erhalten sollen – unabhängig von der allgemeinen Rollenstruktur.
                            </p>

                            <div class="card bg-light border-0 mt-4 mb-4">
                                <div class="card-body">
                                    <h5 class="card-title text-secondary">
                                        <i class="fas fa-key mr-2"></i>So funktioniert es
                                    </h5>
                                    <ol class="mt-3">
                                        <li class="mb-2">Weisen Sie Dokumente einer oder mehreren Sichtbarkeitsgruppen zu</li>
                                        <li class="mb-2">Beschränken Sie den Zugriff ausschließlich auf Mitarbeiter, die denselben Gruppen angehören</li>
                                        <li>Erstellen Sie beliebig viele Sichtbarkeitsgruppen für verschiedene Vertraulichkeitsstufen oder Themenbereiche</li>
                                    </ol>
                                </div>
                            </div>

                            <div class="d-flex align-items-center mt-4">
                                <div class="flex-shrink-0">
                                    <div class="rounded-circle bg-secondary text-white d-inline-flex justify-content-center align-items-center" style="width: 50px; height: 50px;">
                                        <i class="fas fa-shield-alt fa-lg"></i>
                                    </div>
                                </div>
                                <div class="ml-3">
                                    <h5>Umfassender Schutz</h5>
                                    <p class="mb-0">Die Zugriffssteuerung wirkt sich automatisch auch auf alle mit den Dokumenten verknüpften Elemente aus – Aufgaben, Termine und Erinnerungen bleiben ebenso geschützt wie die Dokumente selbst.</p>
                                </div>
                            </div>

                            <div class="alert alert-success mt-4">
                                <i class="fas fa-check-circle mr-2"></i>So gewährleisten Sie ein Höchstmaß an Datenschutz und Informationssicherheit in Ihrer gesamten Organisation.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="card border-0 shadow-sm bg-light mb-4">
                        <div class="card-body p-4">
                            <h4 class="card-title text-secondary mb-4">
                                <i class="fas fa-layer-group mr-2"></i>Beispiele für Sichtbarkeitsgruppen
                            </h4>

                            <div class="row">
                                <div class="col-6 mb-4">
                                    <div class="card border-0 shadow-sm h-100 text-center">
                                        <div class="card-body">
                                            <div class="rounded-circle bg-danger text-white d-inline-flex justify-content-center align-items-center mb-3" style="width: 60px; height: 60px;">
                                                <i class="fas fa-user-tie fa-lg"></i>
                                            </div>
                                            <h5>Geschäftsleitung</h5>
                                            <p class="small mb-0">Strategische Dokumente & Finanzberichte</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 mb-4">
                                    <div class="card border-0 shadow-sm h-100 text-center">
                                        <div class="card-body">
                                            <div class="rounded-circle bg-info text-white d-inline-flex justify-content-center align-items-center mb-3" style="width: 60px; height: 60px;">
                                                <i class="fas fa-users fa-lg"></i>
                                            </div>
                                            <h5>Personalabteilung</h5>
                                            <p class="small mb-0">Mitarbeiterdaten & Verträge</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 mb-4">
                                    <div class="card border-0 shadow-sm h-100 text-center">
                                        <div class="card-body">
                                            <div class="rounded-circle bg-success text-white d-inline-flex justify-content-center align-items-center mb-3" style="width: 60px; height: 60px;">
                                                <i class="fas fa-project-diagram fa-lg"></i>
                                            </div>
                                            <h5>Projekt Alpha</h5>
                                            <p class="small mb-0">Projektspezifische Dokumente</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 mb-4">
                                    <div class="card border-0 shadow-sm h-100 text-center">
                                        <div class="card-body">
                                            <div class="rounded-circle bg-warning text-dark d-inline-flex justify-content-center align-items-center mb-3" style="width: 60px; height: 60px;">
                                                <i class="fas fa-gavel fa-lg"></i>
                                            </div>
                                            <h5>Rechtsabteilung</h5>
                                            <p class="small mb-0">Rechtliche Dokumente & Verträge</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center mt-3">
                                <button class="btn btn-outline-secondary">
                                    <i class="fas fa-plus-circle mr-2"></i>Weitere Sichtbarkeitsgruppen erstellen
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer Section -->
            <div class="card border-0 shadow-sm bg-primary text-white mt-5 mb-4">
                <div class="card-body p-4 text-center">
                    <h3 class="mb-3">Bereit, Ihr Dokumentenmanagement zu revolutionieren?</h3>
                    <p class="lead">Kontaktieren Sie uns noch heute für eine unverbindliche Beratung und Demo!</p>
                    <a class="btn btn-light btn-lg mt-2 text-dark" routerLink="/contact">
                        <i class="fas fa-envelope mr-2"></i>Jetzt Kontakt aufnehmen
                    </a>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="back-to-top" [class.show]="showBackToTop" (click)="scrollToTop()">
    <i class="fas fa-arrow-up"></i>
</div>
